import {
  Box,
  Button,
  TextField,
  Typography,
} from "@mui/material";
import React, { useCallback, useContext } from "react";
import { useEffect } from "react";
import { useState } from "react";
import RoleService from "services/RoleService";
import CheckboxTick from "assets/CheckboxTick.svg";
import CheckboxUntick from "assets/CheckboxUntick.svg";
import { AuthData } from "auth/AuthWarpper";
import { useLocation, useNavigate } from "react-router-dom";
import { SnackbarContext } from "context/snackBarContext";
import UserService from "services/UserService";
import DelegationService from "services/DelegationService";
import LayoutAccessManagement from "components/structure/LayoutAccessManagement";
import { debounce } from "lodash";
import { useTranslation } from "react-i18next";
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import { setHours, setSeconds, differenceInMinutes, setMinutes, differenceInHours, endOfDay, startOfDay } from 'date-fns';
import "./Delegation.css"
import calenderIcon from "assets/user-access/calenderIcon.svg";

const DelegationNew = () => {
  console.log("Component loaded");
  const location = useLocation();
  const { user } = AuthData();
  const navigate = useNavigate();
  const { rowData } = location.state || {};
  const { setOpenAlert, setSeverity, setMessage, handleClose } =
    useContext(SnackbarContext);
  const [userName, setUserName] = useState(rowData?.userName || "");
  const [isActive, setIsActive] = useState(
    rowData?.active === "Active" ? "Active" : "Active"
  );
  const { t, i18n } = useTranslation()
  const [formData, setFormData] = useState({
    profile: rowData?.batOneId || "",
    fieldTechnician: "",
    role: rowData?.profileId || "",
    serviceNumber: rowData?.serviceNumber || "",
    remarks: rowData?.remarks || "",
    countryCode: rowData?.countryCode || "",
    fromBatId: "",
    toBatId: "",
  });

  const [selected, setSelected] = useState([]);
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = React.useState(false);
  const [StartDate, setStartDate] = useState(rowData?.endDate || "");
  const [roleOptions, setRoleOptions] = useState([]);
  const [data, setData] = useState([]);

  const fetchData = async () => {
    setLoading(true);
    const query = {
      batOneId: user?.batOneId,
      pageNumber: 0,
      size: 1000,
      status: null,
    };
    try {
      const response = await RoleService.otherDelegation(query);
      setLoading(false);
      const responseData = response?.data?.response;
      if (Array.isArray(responseData)) {
        const rows = responseData.map((item) => ({
          delegationId: item.delegationId,
          delegate: item.toName,
          batOneId: item.toBATID,
          start: item.startDate,
          end: item.endDate,
          status: item.isActive === true ? "Active" : "Inactive",
        }));
        setData(rows);
      } else {
        console.warn("Unexpected response format:", responseData);
        setData([]); // Clear data if response format is unexpected
      }
    } catch (error) {
      setLoading(false);
      console.error("Error fetching data:", error);
      const errorMessage =
        error?.response?.data?.message ||
        error?.message ||
        "Something went wrong.";
      // setSeverity("error");
      // setMessage(errorMessage);
      // setOpenAlert(true);
      setData([]); // Clear data on error
    } finally {
      setLoading(false); // Ensure loading state is cleared regardless of success or failure
    }
  };

  useEffect(() => {
    if (user?.batOneId) {
      fetchData();
    }
  }, [user?.batOneId]); // Added dependency to ensure re-fetching when user ID changes

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
  };

  const handleSubmitMulti = async (e) => {
    e.preventDefault();
    let validateDates = validateDateDifference(startDates, endDates)
    if (validateDates) return
    setLoading(true);
    try {
      const payload = {
        isActive: isActive === "Active" ? true : false,
        toBATID: formData?.toBatId,
        fromBATID: formData?.fromBatId,
        startDate: new Date(startDates).toISOString(),
        endDate: new Date(endDates).toISOString(),
        delegatedByUser: user.batOneId,
        createdByUser: user.userName,
        modifiedByUser: user.userName,
        createdDateTimeUTC: new Date().toISOString(),
        modifiedDateTimeUTC: new Date().toISOString(),
      };
      const response = await DelegationService.createDelegation(payload);
      setLoading(false);
      if (response.status === 201) {
        navigate("/otherDelegation");
        setSeverity("success");
        setMessage("Added successfully");
        setOpenAlert(true);
        setLoading(false);
      } else {
        console.error("Failed to submit form");
        setSeverity("error");
        setMessage("Failed to submit form");
        setOpenAlert(true);
      }
    } catch (error) {
      setLoading(false);
      let newError = {};
      if (error?.name && error.name === "ValidationError") {
        error?.inner?.forEach((err) => {
          newError[err.path] = err.message;
          setErrors(newError || error?.message);
          return;
        });
      } else {
        setSeverity("error");
        setMessage(error?.response?.data?.message || error?.message);
        setOpenAlert(true);
      }
      setLoading(false);
    }
  };

  const [profileData, setProfileData] = useState([]);
  const [match, setMatch] = useState(false);
  const handleChangeText = (e) => {
    setFormData({ ...formData, profile: e.target.value });
  };
  const [batData, setBatData] = useState("");
  const [open, setOpen] = useState(false);
  const fetchProfileData = useCallback(
    debounce(async (query) => {
      setLoading(true);
      if (query.profile) {
        try {
          const response = await DelegationService.checkSameRole({
            loginBatID: query?.batOneId,
            delegatorBATID: query?.profile,
          });
          setLoading(false);
          // Only update state if the response is different
          if (response?.data?.response !== match) {
            setMatch(response?.data?.response);
          }
        } catch (error) {
          setLoading(false);
          console.error("Error fetching profile data:", error);
          setSeverity("error");
          setMessage(error?.response?.data?.message);
          setOpenAlert(true);
        }
      }
    }, 1000), // 1000ms debounce delay
    [] // Ensure the debounce function is only created once
  );

  useEffect(() => {
    fetchProfileData({ profile: formData.profile, batOneId: user?.batOneId });
  }, [formData.profile, user?.batOneId, match]);

  const [multiMatch, setMultiMatch] = useState(false);

  const fetchProfileData2 = useCallback(
    debounce(async (query) => {
      setLoading(true);
      if (query?.fromBatId && query?.toBatId) {
        if (query?.fromBatId == query?.toBatId) {
          setSeverity("error");
          setMessage(`From "BAT OneID" and To "BAT OneID" should not be same`);
          setOpenAlert(true);
          return;
        }

        if (query?.fromBatId == user?.batOneId || query?.toBatId == user?.batOneId) {
          setSeverity("error");
          setMessage("Cannot delegate to/from myself");
          setOpenAlert(true);
          return
        }

        try {
          const response = await DelegationService.checkSameRole({
            loginBatID: query?.fromBatId,
            delegatorBATID: query?.toBatId,
          });
          setLoading(false);
          setUserName(`${response?.data?.response?.fromUser}`);
          setUserEmail(response?.data?.response?.fromEmail);
          setToUserName(`${response?.data?.response?.toUser}`);
          setToEmail(response?.data?.response?.toEmail);

          // Only update state if the component is still mounted and the response is different
          if (query?.isMounted && response?.data?.response !== multiMatch) {
            // setMultiMatch(response?.data?.response);
          }
        } catch (error) {
          setLoading(false);
          if (query?.isMounted) {
            console.error("Error fetching profile data:", error);
            setSeverity("error");
            setMessage(error?.response?.data?.message || error?.message);
            setOpenAlert(true);
          }
        }
      }
    }, 1000), // 1000ms debounce delay
    [] // Ensure the debounce function is only created once
  );

  useEffect(() => {
    let isMounted = true; // Track if the component is mounted
    fetchProfileData2({
      profile: formData.profile,
      fromBatId: formData.fromBatId,
      toBatId: formData.toBatId,
      isMounted: isMounted,
    });
    return () => {
      isMounted = false; // Cleanup function to avoid state updates if unmounted
    };
  }, [formData.fromBatId, formData.toBatId, multiMatch]); // Add 'match' to dependency array if you want the effect to re-run when it changes

  useEffect(() => {
    const fetchUserData = async () => {
      if (match) {
        try {
          const response = await UserService.FindAdUser(formData.profile);

          // Only update state if the response is different
          setBatData(response?.data?.response);
          setUserName(
            `${response?.data?.response?.givenName ?? ""} ${response?.data?.response?.surName ?? ""
              }`.trim()
          );
        } catch (error) {
          console.error("Error fetching user data:", error);
          setSeverity("error");
          setMessage(`${formData?.profile} One ID does not exist in Agri360 system`);
          setOpenAlert(true);
        }
      }
    };

    fetchUserData();
  }, [match]); // Depend on match to avoid unnecessary re-renders

  const [userEmail, setUserEmail] = useState("");

  const fetchUserData = useCallback(
    debounce(async (query) => {
      setLoading(true);
      if (query.fromBatId) {
        try {
          const response = await UserService.FindAdUser(query.fromBatId);
          setLoading(false);
          // Only update state if the response is different
          setUserName(
            `${response?.data?.response?.givenName ?? ""} ${response?.data?.response?.surName ?? ""
              }`.trim()
          );
          setUserEmail(response?.data?.response?.mail);
        } catch (error) {
          setLoading(false);
          // console.error("Error fetching user data:", error);
          // setSeverity("error");
          // setMessage(`${formData?.fromBatId} One ID does not exist in Agri360 system`);
          // setOpenAlert(true);
        }
      }
    }, 1000), // 1000ms debounce delay
    [] // Ensure the debounce function is only created once
  );

  useEffect(() => {
    fetchUserData({ fromBatId: formData.fromBatId });
  }, [formData.fromBatId]);

  const [toUserName, setToUserName] = useState("");
  const [toEmail, setToEmail] = useState("");

  useEffect(() => {
    const fetchUserData = async () => {
      if (multiMatch) {
        try {
          const response = await UserService.FindAdUser(formData.toBatId);

          // Only update state if the response is different
          setToUserName(
            `${response?.data?.response?.givenName ?? ""} ${response?.data?.response?.surName ?? ""
              }`.trim()
          );

          setToEmail(response?.data?.response?.mail);
        } catch (error) {
          console.error("Error fetching user data:", error);
          setSeverity("error");
          setMessage(`${formData?.toBatId} One ID does not exist in Agri360 system`);
          setOpenAlert(true);
        }
      }
    };

    fetchUserData();
  }, [multiMatch]);

  const toggleIsActive = () => {
    setIsActive((prevIsActive) =>
      prevIsActive === "Active" ? "InActive" : "Active"
    );
  };

  const handleChangeDate = (date) => {
    setStartDate(date); // Store the selected date
  };

  const [endDate, setEndDate] = useState("");
  const [openEnd, setOpenEnd] = useState(false);
  const handleChangeDateEnd = (date) => {
    setEndDate(date); // Store the selected date
  };
  const [startDates, setStartDates] = React.useState(
    setSeconds(setMinutes(setHours(new Date(), 23), 0), 0)
  );
  const [endDates, setEndDates] = React.useState(
    setSeconds(setMinutes(setHours(new Date(), 23), 0), 0)
  );

  const [minTime, setMinTime] = useState(null);
  const [maxTime, setMaxTime] = useState(null);
  useEffect(() => {
    const today = new Date();
    // Set minTime to the current time if today's date is selected
    setMinTime(setHours(setMinutes(today, today.getMinutes()), today.getHours()));
    // Set maxTime to the end of the day (23:59) for the selected date
    setMaxTime(endOfDay(today));
  }, []);
  const handleStartDateChange = (date) => {
    setStartDates(date);
    if (date) {
      const currentTime = new Date();
      if (date.toDateString() === currentTime.toDateString()) {
        // Set minTime to current time for today's date
        setMinTime(setHours(setMinutes(currentTime, currentTime.getMinutes()), currentTime.getHours()));
      } else {
        // If it's not today, set minTime to null
        setMinTime(startOfDay(date));
      }
      // Set maxTime to the end of the day for the selected date
      setMaxTime(endOfDay(date));
    }
  };

  const handleEndDateChange = (date) => {
    setEndDates(date);
    if (startDates) {
      validateDateDifference(startDates, date);
    }
  };

  const validateDateDifference = (startDate, endDate) => {
    let status = false
    const startWithoutTimeDetails = setSeconds(setMinutes(startDate, 0), 0);
    const endWithoutTimeDetails = setSeconds(setMinutes(endDate, 0), 0);

    const minutesDifference = differenceInMinutes(endWithoutTimeDetails, startWithoutTimeDetails);
    if (minutesDifference < 59) {
      setSeverity("error");
      setMessage("Difference between from and To Date & time should be more then 1 hour.");
      setOpenAlert(true);
      status = true
    }
    return status
  };

  return (
    <LayoutAccessManagement>
      <Box sx={{ paddingBottom: "150px" }}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            minHeight: "65vh",
            background: "#f0f3f6",
            boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px;",
            padding: "25px",
            borderRadius: "6px",
            flexDirection: "column",
            gap: "20px",
          }}
        >
          {match === false && (
            <Box
              sx={{
                background: "#ffffff",
                width: "473px",
                display: "flex",
                flexDirection: "column",
                gap: "15px",
                borderRadius: "16px",
                boxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px;",
              }}
            >
              <Box
                sx={{
                  textAlign: "center",
                  fontWeight: 500,
                  color: "#191E31",
                  p: 2,
                }}
              >
                {t("otherDelegation.otherDelegation")}
              </Box>

              <Box sx={{ p: 2 }}>
                <TextField
                  id="profile"
                  label={t("otherDelegation.fromBatOneID")}
                  value={formData.fromBatId}
                  disabled={toUserName !== ""}
                  name="fromBatId"
                  onChange={handleChange}
                  fullWidth
                  onInput={(e) => {
                    e.target.value = e.target.value.replace(/[^0-9]/g, '');
                  }}
                ></TextField>
              </Box>

              {toUserName !== "" && (
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    fontWeight: 500,
                    color: "#191E31",
                    borderBottom: "2px solid #CFD5E0",
                    p: 2,
                  }}
                >
                  <Typography sx={{ fontWeight: 500, color: "#191E31" }}>
                    {t("administratorAccess.name")}: {userName}
                  </Typography>
                  <Typography sx={{ fontWeight: 500, color: "#191E31" }}>
                    {t("administratorAccess.email")}: {userEmail}
                  </Typography>
                </Box>
              )}
              <Box sx={{ p: 2 }}>
                <TextField
                  id="profile"
                  label={t("otherDelegation.toBatOneID")}
                  value={formData.toBatId}
                  disabled={toUserName !== ""}
                  name="toBatId"
                  onChange={handleChange}
                  fullWidth
                  onInput={(e) => {
                    e.target.value = e.target.value.replace(/[^0-9]/g, '');
                  }}
                ></TextField>
              </Box>
              {toUserName !== "" && (
                <>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "center",
                      alignItems: "center",
                      fontWeight: 500,
                      color: "#191E31",
                      borderBottom: "2px solid #CFD5E0",
                      p: 2,
                    }}
                  >
                    <Typography sx={{ fontWeight: 500, color: "#191E31" }}>
                      {t("administratorAccess.name")}: {toUserName}
                    </Typography>
                    <Typography sx={{ fontWeight: 500, color: "#191E31" }}>
                      {t("administratorAccess.email")}: {toEmail}
                    </Typography>
                  </Box>
                  <Box sx={{ p: 2, borderBottom: "2px solid #CFD5E0" }}>

                    <Box className="main-area">
                      <div className="datepicker-container">
                        <DatePicker
                          selected={startDates}
                          minDate={new Date()}
                          minTime={minTime}  // Disable past time
                          maxTime={maxTime}  // Set max time to the end of the day
                          onChange={handleStartDateChange}
                          showTimeSelect
                          timeIntervals={60}
                          dateFormat="dd/MM/YYYY - HH:mm"
                          timeFormat="HH:mm"
                          placeholderText="Start Date"
                          customInput={
                            <TextField
                              label="Start Date"
                              variant="outlined"
                              fullWidth
                              InputProps={{
                                style: {
                                  fontSize: '16px',
                                  padding: '10px', // You can adjust this to match Material-UI's input styling
                                },
                              }}
                              InputLabelProps={{
                                shrink: !!startDates, // Only shrink label when there's a value
                              }}
                            />
                          }
                        />
                        <img src={calenderIcon} className="datepicker-icon" />
                      </div>
                    </Box>
                    <Box sx={{ marginTop: "20px" }} className="main-area">
                      <div className="datepicker-container">
                        <DatePicker
                          selected={endDates}
                          minDate={new Date()}
                          // onChange={(date) => {
                          //   if (date.getDate() === new Date().getDate()) {
                          //     setMinTime(setHours(setMinutes(new Date(), 0), 18));
                          //   } else {
                          //     setMinTime(setHours(setMinutes(new Date(), 0), 0));
                          //   }
                          //   setEndDates(date);
                          // }}
                          onChange={handleEndDateChange}
                          showTimeSelect
                          // minTime={editFlag ? minTime : false}
                          // maxTime={editFlag ? maxTime : false}
                          timeIntervals={60}
                          dateFormat="dd/MM/YYYY - HH:mm"
                          timeFormat="HH:mm"
                          placeholderText="End Date"
                          customInput={
                            <TextField
                              label="End Date"
                              variant="outlined"
                              fullWidth
                              InputProps={{
                                style: {
                                  fontSize: '16px',
                                  padding: '10px', // You can adjust this to match Material-UI's input styling
                                },
                              }}
                              InputLabelProps={{
                                shrink: !!endDates, // Only shrink label when there's a value
                              }}
                            />
                          }
                        />
                        <img src={calenderIcon} className="datepicker-icon" />
                      </div>
                    </Box>
                  </Box>
                  <Box>
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: "10px",
                        pb: 2,
                        cursor: "pointer",
                        borderBottom: "2px solid #CFD5E0",
                      }}
                      onClick={toggleIsActive}
                    >
                      <img
                        src={
                          isActive === "Active" ? CheckboxTick : CheckboxUntick
                        }
                        alt="checkbox"
                      />
                      <Typography>
                        {isActive === "Active" ? "Active" : "Inactive"}
                      </Typography>
                    </Box>
                  </Box>
                  <Box
                    sx={{
                      alignItems: "center",
                      justifyContent: "center",
                      display: "flex",
                      gap: "20px",
                      p: 2,
                    }}
                  >
                    <Button
                      sx={{
                        borderRadius: 2,
                        background: "#102A62",
                        height: 54,
                        color: "#ffffff",
                        fontWeight: 600,
                        backgroundColor: "#737D86",
                        width: { xs: "100%", md: "156px" },
                        "&:hover": {
                          backgroundColor: "#737D86",
                        },
                      }}
                      onClick={() => navigate(-1)}
                    >
                      {t("back")}
                    </Button>
                    <Button
                      sx={{
                        borderRadius: 2,
                        background: "#EF7D00",
                        color: "#ffffff",
                        fontWeight: 600,
                        height: 54,
                        width: { xs: "100%", md: "156px" },
                        "&:hover": {
                          backgroundColor: "#EF7D00",
                        },
                      }}
                      disabled={loading}
                      onClick={handleSubmitMulti}
                    >
                      {t("assign")}
                    </Button>
                  </Box>
                </>
              )}
            </Box>
          )}
        </Box>
      </Box>
    </LayoutAccessManagement>

  );
};

export default DelegationNew;
